module.exports = __webpack_public_path__ + "static/media/excelDisabledA.e152b5c6.svg";